export const HEADERS = ['No.', 'Name', 'IP', 'Script location', 'Actions'];
